import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-create-folder-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
      <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl border border-gray-200 dark:border-gray-700 w-full max-w-sm mx-4 p-6">
        <h3 class="text-base font-semibold text-gray-900 dark:text-white mb-4">Create Folder</h3>
        <input
          type="text"
          [(ngModel)]="folderName"
          (keydown.enter)="confirm()"
          (keydown.escape)="cancel.emit()"
          placeholder="Folder name"
          autofocus
          class="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        @if (error) {
          <p class="mt-2 text-xs text-red-500">{{ error }}</p>
        }
        <div class="flex justify-end gap-2 mt-5">
          <button
            (click)="cancel.emit()"
            class="px-4 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors">
            Cancel
          </button>
          <button
            (click)="confirm()"
            class="px-4 py-2 text-sm rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium transition-colors">
            Create
          </button>
        </div>
      </div>
    </div>
  `
})
export class CreateFolderDialogComponent {
  @Output() confirmed = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();

  folderName = '';
  error = '';

  confirm(): void {
    const name = this.folderName.trim();
    if (!name) { this.error = 'Folder name is required'; return; }
    if (/[/\\]/.test(name)) { this.error = 'Folder name cannot contain / or \\'; return; }
    this.confirmed.emit(name);
  }
}
